import React, { FC, ReactElement } from 'react';
import '../OfferAvailability/OfferAvailabilityHeader.scss';
import withLocalization from '../hoc/withLocalization';

const EligibilityHeader: FC<any> = (props: any): ReactElement => {
  const { localize } = props;
  return (
    <>
      <div className="dateHeaderWrapper">
        <h3 className="headBaskerville">
          {localize('preview-sales-engine.static-content.copy.select-destination-page.dop-link')}
        </h3>
      </div>
    </>
  );
};
export default withLocalization(EligibilityHeader);
